import { render, staticRenderFns } from "./AgreementPrivateLabelContentPt.vue?vue&type=template&id=8cc7abc4&scoped=true"
import script from "./AgreementPrivateLabelContentPt.vue?vue&type=script&lang=js"
export * from "./AgreementPrivateLabelContentPt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc7abc4",
  null
  
)

export default component.exports